import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import { useTranslation } from '../../language';
import ProfilePage from "./SelfServiceUser/ProfilePage";
import FemaleProfileCard from "./SelfServiceUser/FemaleProfileCard";
import Grid from '@mui/material/Grid';
import { useAuth } from '../../provider';


export default function UserAdminWelcome() {

const { t } = useTranslation();
const { state } = useAuth();
const isFemale = state.user?.gender === "F";

return (

<PageProtectedLayout
    headline={t('page_hl_account')}
    specify={t('page_sp_personal_data')}
     >

    {/* Main Page Content */}
    <Grid container spacing={1} sx={{maxWidth: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <ProfilePage />
      {isFemale && <FemaleProfileCard />}

    </Grid>

</PageProtectedLayout>

)}